<template>
    <div id="verification-queue-container">
        <card title="Rx Audit Verification">
            <b-row>
                <b-col cols="7">
                    <b-row>
                        <b-col>
                            <SearchComponent v-model="storeFilter"
                                             :label="`Store`"
                                             :search-u-r-l="`/Store`"
                                             :params="{active: true}"
                                             :prepopulate="true"
                                             :option-label="storeLabel"
                                             @input="searchFiltered">
                            </SearchComponent>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group>
                                <b-input class="mt-4 py-3"
                                         v-model="searchString"
                                         autofocus
                                         label="Search"
                                         placeholder="Rx, Patient Name, Drug Name"
                                         @input="awaitEndOfTyping"></b-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col>
                    <b-button variant="dark" @click="clearFilters">
                        Clear Filters
                    </b-button>
                </b-col>
            </b-row>

            <OrdersListComponent :orders="orders"
                                 :audit="true" @change="loadOrders" />
        </card>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import SearchComponent from '@/components/SearchComponent.vue';
    import {LockHandler, Lock} from '@/mixins/LockHandler';
    import Axios, {AxiosError} from 'axios';
    import {Component, Watch, Mixins, Ref} from 'vue-property-decorator';
    import Card from "@/components/Cards/Card.vue";
    import {Patient, PatientProgram} from '@/models/Patient';
    import { DatePicker } from "element-ui";
    import OrdersListComponent from '@/components/Order/OrdersListComponent.vue';
    import { Store } from '@/models/Store';
    import { Order } from '@/models/Order';
    import { Prescription, DAWCode, OriginCode, RefillStatusCode } from '@/models/Prescription';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

     @Component({
        name: "RxAuditVerificationPage",
        components: {
            SearchComponent,
            [DatePicker.name]: DatePicker,
            OrdersListComponent
        },
    })

    export default class RxAuditVerificationPage extends Vue {
        private orders: Array<Order> = [];
        private searchedOrder: Order | null = null;
        private searchString: string = "";
        private timeout: any = null;

        @Watch('patient') onPatientChanged(value: Patient | null, oldValue: Patient | null) {
        }

        created() {
            if (this.routeStoreId) {
                this.storeFilter.id = this.routeStoreId;
                this.loadOrders();

            }

            else {
                Axios.get(`/Store/`).then(response => {
                    this.storeFilter = response.data[0];
                }).then(() => {
                    this.loadOrders();
                });
            }
        }

        mounted() {
            window.scrollTo(0, 0);
        }

        get routeStoreId(): number {
            let res = 0;
            res = parseInt(this.$route.params.storeId);
            if (isNaN(res))
                return 0;
            return res;
        }

        loadOrders() {
            //Get patient's prescriptions and format the data to be shown in the grid.
            Axios.get(`/Order/pending-pv2`, {
                params: {
                    patientId: null,
                    prescriberId: null,
                    programId: null,

                    storeID: null,
                    rxNumber: null,
                    rfNumber: null,

                    orderStoreId: this.storeFilter?.id
                }
            })
                .then(response => {
                    this.orders = response.data;
                })
                .catch(error => {
                    console.warn(error);
                });
        }

        rxID(prescription: Prescription | null): string {
            if (!prescription) return "";
            return `${prescription.storeID}-${prescription.rxNumber}-${prescription.rfNumber}`;
        }

        private storeFilter: Store = {} as Store;
        storeLabel(object: Store) {
            if (object?.id)
                return object.name;
            else '';
        }

        clearFilters() {
            this.searchString = "";
            this.storeFilter = {} as Store;
            this.loadOrders();
            console.log(this.$refs.searchString);
        }

        awaitEndOfTyping() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.searchFiltered();
            }, 250);
        }

        searchFiltered() {
            clearTimeout(this.timeout);
            Axios.get(`/Order/pending-search/`, {
                params: {
                    storeId: this.storeFilter.id,
                    searchTerm: this.searchString
                }
            })
                .then(response => {
                    this.orders = response.data;
                    if (this.orders.length < 1) {
                        this.$notification(NotificationOptions.error("No Order Found"));
                    }
                }).catch(error => {
                    console.warn(error);
                });
        }
    }

</script>